import { Component, OnInit } from '@angular/core';
import { NbMenuItem, NbSidebarService } from '@nebular/theme';
import { ThemeService } from '@app/service/theme.service';
import { NbMenuService } from '@nebular/theme';
import { GlobalService } from '@app/service/global.service';
import { QuickQuote } from '@data/schema';
import { occupancy } from '@data/schema/quote-constants';
import { employment } from '@data/schema/quote-constants';
import { transaction } from '@data/schema/quote-constants';

@Component({
  selector: 'app-quickquote-layout',
  templateUrl: './quickquote-layout.component.html',
  styleUrls: ['./quickquote-layout.component.scss'],
  providers: [NbSidebarService]
})
export class QuickquoteLayoutComponent implements OnInit {
  constructor(
    private themeService: ThemeService,
    private menuService: NbMenuService,
    private globalService: GlobalService,
    private sidebarService: NbSidebarService
  ) {}
  public theme = 'my-light-theme';
  private globalQQ: QuickQuote;
  menuItems: NbMenuItem[] = [
    {
      title: 'Property Location',
      link: '/quickquote/property-location'
    },
    {
      title: 'Transaction',
      link: '/quickquote/transaction'
    },
    {
      title: 'Occupancy',
      link: '/quickquote/occupancy'
    },
    {
      title: 'Employment',
      link: '/quickquote/employment'
    },
    {
      title: 'Income Documentation',
      link: '/quickquote/income-documentation'
    },
    {
      title: 'Property Information',
      link: '/quickquote/property-info'
    },
    {
      title: 'Property Value',
      link: '/quickquote/property-value'
    },
    {
      title: 'Requested Loan Amount',
      link: '/quickquote/purchase-loan-amount'
    },
    {
      title: 'Estimated Credit Score',
      link: '/quickquote/credit-score'
    },
    {
      title: 'Mortgage Insurance',
      link: '/quickquote/mortgage-insurance'
    },
    {
      title: 'Tax and Insurance Escrows',
      link: '/quickquote/tax-insurance-escrows'
    },
    {
      title: 'Pre-Payment Penalty',
      link: '/quickquote/pre-payment-penalty'
    },
    {
      title: 'Request Rate Quote',
      link: '/quickquote/request-rate-quote'
    },
    {
      title: 'Search Results',
      link: '/quickquote/search-results'
    },
    {
      title: 'Product Details',
      link: '/quickquote/product-details'
    }

  ];

  ngOnInit() {
    this.globalService.getQuickQuote().subscribe(quickQuote => {
      this.globalQQ = quickQuote;
    });
    this.themeService.setDarkTheme(false);

    this.themeService.getDarkTheme().subscribe(theme => {
      this.theme = theme ? 'my-dark-theme' : 'my-light-theme';
    });
  }

  onActivate(event) {
    this.menuItems = this.menuItems.map(menuItem => {
      if (this.globalQQ) {
        if (
          menuItem.title === 'Income Documentation' &&
          (this.globalQQ.employmentType === employment.RETIRED ||
            this.globalQQ.employmentType === employment.WORK_FOR_COMPANY)
        ) {
          menuItem.hidden = true;
        } else if (
          menuItem.title === 'Property Value' &&
          this.globalQQ.transactionType === transaction.PURCHASE
        ) {
          menuItem.hidden = true;
        } else if (menuItem.title === 'Requested Loan Amount') {
          if (this.globalQQ.transactionType === transaction.PURCHASE) {
            menuItem.link = '/quickquote/purchase-loan-amount';
          } else {
            menuItem.link = '/quickquote/refinance-loan-amount';
          }
        } else if (
          menuItem.title === 'Mortgage Insurance' &&
          !this.globalService.isMIMandatory()
        ) {
          menuItem.hidden = true;
        } else if (
          menuItem.title === 'Pre-Payment Penalty' &&
          this.globalQQ.occupancyType !== occupancy.INVESTMENT
        ) {
          menuItem.hidden = true;
        } else if (
          menuItem.title === 'Tax and Insurance Escrows' &&
          !this.globalService.isTaxAndEscrowsMandatory()
        ) {
          menuItem.hidden = true;
        } else {
          menuItem.hidden = false;
        }
      }
      return menuItem;
    });
  }
}
